import { SingleAggregateAuditDeactivableModelInterface, SingleAggregateIdentityInterface } from "@nts/std/interfaces";
import { OCCAuditDeactivableRootViewModel } from "../occ-audit-deactivable-root-view-model";
import { NumericPropertyViewModel } from "../base-type/numeric-property-view-model";

export class SingleAggregateAuditDeactivableRootViewModel<
  TModel extends SingleAggregateAuditDeactivableModelInterface<TIdentity>,
  TIdentity extends SingleAggregateIdentityInterface
> extends OCCAuditDeactivableRootViewModel<
  TModel,
  TIdentity
> {
  #fixedIdentity: NumericPropertyViewModel<number>;

  public get fixedIdentity(): NumericPropertyViewModel<number> {
    return this.getNumericPropertyViewModel<number>({
      action: (value) => this.#fixedIdentity = value,
      value: this.#fixedIdentity,
      propertyName: 'fixedIdentity',
    });
  }
}
